import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/inbox')({
  staticData: {
    permissionSection: 'quality',
    section: 'Quality',
    breadcrumb: 'Inbox',
    layout: 'full-height',
    // `?selected=` names a specific card, so it can't survive a partner
    // switch — see the flag's docs in router-types.d.ts.
    resetSearchOnPartnerChange: true,
  },
  component: InboxLayoutRoute,
});

function InboxLayoutRoute() {
  return <Outlet />;
}
